import React, { useState, useEffect } from 'react'
import { Badge, Input, Button, InputGroup } from 'reactstrap'
import moment from 'moment'
import { updateCustomerDetails } from '../../helpers/chat_helper'

const CustomerInfo = ({ conversation, onUpdate }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        reference_no: ''
    })

    const [loading, setLoading] = useState({}) // { email: false, phone: false ... }

    useEffect(() => {
        if (conversation) {
            setFormData({
                name: conversation.customer_name || '',
                email: conversation.customer_email || '',
                phone: conversation.customer_phone || '',
                reference_no: conversation.reference_no || ''
            })
        }
    }, [conversation])

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }))
    }

    const handleSubmit = async (field) => {
        if (!conversation) return

        setLoading(prev => ({ ...prev, [field]: true }))
        try {
            // Map field names to backend expected keys if necessary
            const payload = {
                [field === 'name' ? 'customer_name' :
                    field === 'email' ? 'customer_email' :
                        field === 'phone' ? 'customer_phone' : field]: formData[field]
            }

            await updateCustomerDetails(conversation.id, payload)
            // Call parent to update local state immediately
            if (onUpdate) {
                onUpdate(payload)
            }
            // Alert or toast could go here
        } catch (error) {
            console.error(`Failed to update ${field}:`, error)
        } finally {
            setLoading(prev => ({ ...prev, [field]: false }))
        }
    }

    // Helper to render input with conditional submit button
    const renderInput = (label, field, type = "text", originalValue) => {
        return (
            <div className="mb-3">
                <small className="text-muted d-block mb-1">{label}</small>
                <InputGroup size="sm">
                    <Input
                        type={type}
                        value={formData[field]}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        placeholder={`Enter ${label}`}
                    />
                    {/* Show submit button ONLY if original value was empty/missing, per requirements */}
                    {!originalValue && (
                        <Button
                            color="primary"
                            disabled={!formData[field] || loading[field]}
                            onClick={() => handleSubmit(field)}
                        >
                            {loading[field] ? '...' : 'Submit'}
                        </Button>
                    )}
                </InputGroup>
            </div>
        )
    }

    if (!conversation) {
        return (
            <div className="text-center py-4 text-muted">
                <i className="mdi mdi-account-outline" style={{ fontSize: '48px' }}></i>
                <p className="mt-2">No conversation selected</p>
            </div>
        )
    }

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className="info-header">
                Customer Info
            </div>

            <div className="info-content">
                {renderInput("Name", "name", "text", conversation.customer_name)}
                {renderInput("Email", "email", "email", conversation.customer_email)}
                {renderInput("Reference No", "reference_no", "text", conversation.reference_no)}
                {renderInput("Contact No", "phone", "text", conversation.customer_phone)}

                <div className="mb-4">
                    <small className="text-muted d-block mb-1">Status</small>
                    <div>
                        <Badge color="success" className="px-2 py-1">{conversation.status}</Badge>
                    </div>
                </div>

                {conversation.tags && conversation.tags.length > 0 && (
                    <div className="mb-4">
                        <small className="text-muted d-block mb-1">Tags</small>
                        <div className="mt-1">
                            {conversation.tags.map((tag, index) => (
                                <Badge key={index} color="info" className="me-1 mb-1">
                                    {tag}
                                </Badge>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CustomerInfo
